module.exports = __webpack_public_path__ + "static/img/30016 (4).b641277.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30016 (4).webp
// module id = y+jM
// module chunks = 14